module.exports = __webpack_public_path__ + "static/media/down_expand_blue2.96a9307f.svg";